import React, { useEffect } from 'react';
import {
  ListingDetailsType,
  CustomFieldsType,
  addListingDetailsType,
} from '~addListing/types';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Input } from '@aqarmap/aqarmap-ui';
import { handleAttributeChange } from '~addListing/utils/handleAttributeChange';

const Apartments = ({
  listing,
  customFieldsData,
  errorAttributeIds,
  setErrorAttributeIds,
}: {
  listing: ListingDetailsType;
  customFieldsData: { attributes: CustomFieldsType[] };
  errorAttributeIds: number[];
  setErrorAttributeIds: React.Dispatch<React.SetStateAction<number[]>>;
}) => {
  const apartmentsKey = 'apartments';
  const { t } = useTranslation('app');
  const listingPropertyTypeId = listing?.property_type.id;
  const apartmentsData = customFieldsData.attributes?.find(
    (field: CustomFieldsType) => field.name === apartmentsKey,
  );
  const apartmentsDataId = Number(apartmentsData?.id);
  const isError = errorAttributeIds.includes(apartmentsDataId);

  const renderApartments = Object.values(
    apartmentsData?.virtualPropertyTypesIds || {},
  ).includes(listingPropertyTypeId);

  const { setValue, getValues } = useFormContext<addListingDetailsType>();
  const defaultApartmentsValue =
    listing?.attributes.find((att) => att.custom_field.id === apartmentsDataId)
      ?.value || 0;

  if (!renderApartments) return null;

  useEffect(() => {
    setValue(
      'attributes',
      handleAttributeChange(
        getValues('attributes'),
        apartmentsDataId,
        defaultApartmentsValue,
      ),
    );
  }, [isError]);

  return (
    <Input
      label={{
        text: t('apartments'),
        className: 'text-title_4 text-black',
      }}
      field={{
        placeholder: t('apartmentsPlaceholder'),
        className:
          'text-gray__dark_2 text-gray__dark_2 placeholder:text-gray__dark_1 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-moz-appearance:textfield]',
        type: 'number',
        defaultValue:
          defaultApartmentsValue !== 0 ? defaultApartmentsValue : '',
        onChange: (e) => {
          const value = Number(e.target.value);
          if (value >= 0)
            handleAttributeChange(
              getValues('attributes'),
              apartmentsDataId,
              value,
            );
          else
            handleAttributeChange(getValues('attributes'), apartmentsDataId, 0);
        },
        min: 0,
        onFocus: () =>
          setErrorAttributeIds((prev) =>
            prev.filter((id) => id !== apartmentsDataId),
          ),
        onWheel: (e) => (e.target as HTMLInputElement).blur(),
      }}
      error={isError ? t('apartmentsError') : ''}
    />
  );
};

export default Apartments;
